import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignTopThreadsLoadAction } from '../../domains/campaignTopThreads/actions.types';

import { CampaignTopThreadsLifecycle } from './types';

const initialState: CampaignTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<CampaignTopThreadsLifecycle, CampaignTopThreadsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN_TOP_THREADS.LOAD_PENDING':
      return setPending();
    case 'CAMPAIGN_TOP_THREADS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.campaignTopThreads);
    case 'CAMPAIGN_TOP_THREADS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
